import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import MakeAsyncFunction from 'react-redux-promise-listener';
import { Form, Field } from 'react-final-form';
import InputField from './InputField';
import { promiseListener } from 'src/store';

function FormBody({ handleSubmit, invalid, submitting }){
    const disableSubmit = invalid || submitting;
    return (
        <form onSubmit={handleSubmit}>
            <div className="form-group mb-3">
                <Field
                    name="username"
                    placeholder="CPF"
                    component={InputField}
                    type="text"
                    icon="ni-circle-08"
                    />
            </div>
            <div className="form-group">
                <Field
                    name="password"
                    placeholder="Senha"
                    component={InputField}
                    type="password"
                    icon="ni-lock-circle-open"
                />
            </div>
            <div className="text-center">
                <button type="submit" disabled={disableSubmit} className="btn btn-danger my-4">Entrar</button>
            </div>
            <div className="text-center">
                <Link to="/senha" className="text-muted">
                    <small>Esqueceu sua senha?</small>
                </Link>
            </div>
        </form>
    );
}

const LoginForm = () => (
    <MakeAsyncFunction
        listener={promiseListener}
        start="LOGIN_SUBMIT"
        resolve="LOGIN_SUCCEEDED"
        reject="LOGIN_FAILED"
        >{submit => (
            <Form
                onSubmit={submit}
                // validate={loginValidations}
                render={(props) => ( <FormBody {...props} />)}
            />
        )}
    </MakeAsyncFunction>
);

export default LoginForm;



// WEBPACK FOOTER //
// ./src/components/Pages/Login/Form.js